import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';
import { LEASE_DEALS_PATH, LEASE_DEALS_STATE_PATH } from 'site-modules/shared/constants/lease-deals/routes';

export const routes = [
  {
    path: LEASE_DEALS_PATH,
    exact: true,
    page: getLoadablePage(() => {
      return import(/* webpackChunkName: "lease-deals" */ '../../lease-deals/pages/lease-deals-definition');
    }),
    enableLooseEtag: true,
  },
  {
    path: LEASE_DEALS_STATE_PATH,
    exact: true,
    page: getLoadablePage(() => {
      return import(/* webpackChunkName: "lease-deals" */ '../../lease-deals/pages/lease-deals-state-definition');
    }),
    enableLooseEtag: true,
    shouldCallParseApi: true,
    disableFlatUrlUserSetLocation: true,
  },
];
